/**
 * web-api.js — 其他 Web 标准 API 封装
 * 职责：在取消原生注入后，使用浏览器标准 API 替代原 callHandler 实现
 * 蓝牙相关功能请使用 web-bluetooth.js
 */

import { updateStore } from './platform'

/** 获取地理位置（替代原生 getLocation） */
export function getLocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      updateStore('updateLocation', '')
      resolve('')
      return
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const loc = `${pos.coords.longitude},${pos.coords.latitude}`
        updateStore('updateLocation', loc)
        resolve(loc)
      },
      () => {
        updateStore('updateLocation', '')
        resolve('')
      }
    )
  })
}

/** 获取定位权限状态 */
export async function getLocationAuth() {
  if (!navigator.permissions) {
    return { granted: false }
  }
  try {
    const result = await navigator.permissions.query({ name: 'geolocation' })
    return { granted: result.state === 'granted' }
  } catch (e) {
    return { granted: false }
  }
}

/** 获取用户信息（优先 localStorage，否则返回 mock） */
export function getUserInfo() {
  try {
    const cached = localStorage.getItem('ses_user_info')
    if (cached) {
      updateStore('updateUserInfo', cached)
      return JSON.parse(cached)
    }
  } catch (e) { /* ignore */ }
  const mock = { userId: 'web001', userName: '网页用户', dealerCode: 'WEB01' }
  updateStore('updateUserInfo', JSON.stringify(mock))
  return mock
}

/** 改变状态栏颜色 — 浏览器环境无操作 */
export function changeBarColor(color) {
  console.log('[WebAPI] changeBarColor 无操作:', color)
}

/** 上传信息 — 无后端地址，仅打印日志 */
export async function uploadInfo(data) {
  console.log('[WebAPI] uploadInfo:', data)
  return { code: '00', msg: '上传成功(Web)' }
}

/** 设置里程 — 仅更新 Store */
export async function setMileage(mileage) {
  updateStore('updateSetMileage', mileage)
  return { code: '00', value: mileage }
}

/** 获取 MVCI 列表 — 返回空数组 */
export async function GET_MVCI_LIST() {
  return []
}

/** 添加服务数据 — 无后端地址，仅打印日志 */
export async function ADD_SERVICE_DATA(data) {
  console.log('[WebAPI] ADD_SERVICE_DATA:', data)
  return { code: '00' }
}

/** 通用 callHandler — 原生桥接已取消，返回未实现提示 */
export function callHandler(name, data, callback) {
  console.warn('[WebAPI] callHandler 未实现（原生桥接已取消）:', name, data)
  if (callback) callback({ code: '2', msg: '原生桥接已取消，方法未实现: ' + name })
}

/** 通用 registerHandler — 原生桥接已取消，返回未实现提示 */
export function registerHandler(name, callback) {
  console.warn('[WebAPI] registerHandler 未实现（原生桥接已取消）:', name)
}
